export enum Modality {
  BANK_SLIP = 'BANK_SLIP',
  PIX = 'PIX',
  HYBRID = 'HYBRID',
}
